import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";

interface Props {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const authUser = useSelector((state: StoreState) => state.authUser);
  const location = useLocation();
  
  const token = authUser?.token;
  const isAuthenticated = token && typeof token === "string" && token.length > 0;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
};

export default ProtectedRoute;